export default __webpack_public_path__ + "static/media/chailatte.5b4b1a24.jpg";